import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { v4 as uuid } from 'uuid'

import AccordionItem from './AccordionItem'


const Accordion = ({ items, autoClose }) => {
  const [qualifiedItems, setQualifiedItems] = useState([]);

  useEffect(() => {
    const generateQualifiedItem = item => ({
      id: uuid(),
      opened: false,
      ...item
    })

    setQualifiedItems(items.map(generateQualifiedItem))
  },
  [items])

  const onItemToggle = (itemId) => {
    const getDefaultItemOpenedState = item => (autoClose ? false : item.opened)
    const calculateItemOpenedState = item => ({
      ...item,
      opened: (item.id === itemId)
        ? !item.opened
        : getDefaultItemOpenedState(item)
    })

    setQualifiedItems(qualifiedItems.map(calculateItemOpenedState))
  }

  return (
    <div className="accordion">
      {
        qualifiedItems.map(({
          id, title, content, opened
        }) => (
          <AccordionItem
            key={id}
            title={title}
            content={content}
            isOpened={opened}
            onToggle={() => onItemToggle(id)}
          />
        ))
      }
    </div>
  )
}

// Accordion.Item = AccordionItem;

Accordion.defaultProps = {
  autoClose: false
}

Accordion.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    heading: PropTypes.string,
    content: PropTypes.element
  })).isRequired,
  autoClose: PropTypes.bool
}

export default Accordion
